window.document.addEventListener('DOMContentLoaded', function () {
    let players = [...document.querySelectorAll('[data-player]')];

    if (players) {
        players.forEach(player => {
            new NLMKVideohostingPlayer(player.getAttribute('data-player') ,player.id, player.getAttribute('data-video-id'));
        })
    }
});

// обертка для Rutube
const Rutube = function () {
    const EMBEDED_API_URI = '//rutube.ru/play/embed/';
    const PREFFIX_PLAYER_ID = 'rt-';

    this.Player = function (selector, config) {
        if (!selector) {
            throw new Error('The Player element must be specified.');
        }

        this.selector = selector;
        this.config = config;

        return this.renderOnPage();
    };

    this.renderOnPage = function () {
        const element = document.createElement('iframe');

        let options = {
            id: PREFFIX_PLAYER_ID + this.selector,
            width: this.config.width || 720,
            height: this.config.height || 405,
            src: EMBEDED_API_URI + this.config.videoId,
            frameBorder: 0,
            allow: 'autoplay',
        };

        for (let property in options) {
            element[property] = options[property];
        }

        //атрибуты для полноэкранного режима
        element.setAttribute('webkitAllowFullScreen', '');
        element.setAttribute('mozallowfullscreen', '');
        element.setAttribute('allowFullScreen', '');

        document.getElementById(this.selector).appendChild(element);
    };

    this.checkPlayerState = function (event) {
        if (!this.config.events) return;

        const {onStateChange} = this.config.events;

        if (onStateChange) {
            return onStateChange(event);
        }
    };

    for (let [iterator, type] of Object.entries({
        play: 'play',
        pause: 'pause',
        stop: 'stop',
        seekTo: 'setCurrentTime',
    })) {
        this[iterator] = function (data = {}) {
            document
                .getElementById(PREFFIX_PLAYER_ID + this.selector)
                .contentWindow.postMessage(
                JSON.stringify({
                    type: 'player:' + type,
                    data: data,
                }),
                '*'
            );
        };
    }

    window.addEventListener(
        'message',
        function (event) {
            const receivedMessage = JSON.parse(event.data);

            switch (receivedMessage.type) {
                case 'player:changeState':
                    this.checkPlayerState(receivedMessage.data.state);

                    break;
            }
        }.bind(this),
        0
    );
};

function NLMKVideohostingPlayer(player, containerID, videoID) {
    let iframeBlock = document.querySelector(`#${containerID} .videohosting-player__iframe`);

    function addClass(element, addingClass) {
        element.className += ' ' + addingClass;
    }

    function removeClass(element, removingClass) {
        element.className = element.className.replace(new RegExp(removingClass, 'g'), '');
    }

    function Controls() {
        let controlsBlock = window.document.querySelector(`#${containerID} .videohosting-player__controls`);
        let spinner = window.document.querySelector(`#${containerID} .videohosting-player__spinner`);
        let playButton = window.document.querySelector(`#${containerID} .videohosting-player__play-button`);

        this.getControlsBlock = function () {
            return controlsBlock;
        }
        this.hideControlsBlock = function () {
            addClass(controlsBlock, hideClass);
        }
        this.showControlsBlock = function () {
            removeClass(controlsBlock, hideClass);
        }
        this.hidePlayButton = function () {
            addClass(playButton, hideClass);
        }
        this.showPlayButton = function () {
            removeClass(playButton, hideClass);
        }
        this.hideSpinner = function () {
            removeClass(spinner, 'box-circle-preloader__overlay-active');
        }
        this.showSpinner = function () {
            addClass(spinner, 'box-circle-preloader__overlay-active');
        }
        this.getControlsBlock = function () {
            return controlsBlock;
        }
    }

    function Errors() {
        let _this = this;
        let errorsBlock = window.document.querySelector(`#${containerID} .videohosting-player__errors`);
        let errorTextBlock = window.document.querySelector(`#${containerID} .videohosting-player__error-text`);
        let cookiesErrorText = 'Для просмотра содержимого разрешите работу с куки';

        this.hideErrorsBlock = function () {
            addClass(errorsBlock, hideClass);
        }

        this.showErrorsBlock = function () {
            removeClass(errorsBlock, hideClass);
        }

        this.setErrorText = function (text) {
            errorTextBlock.innerHTML = text;
        }

        this.showCookieError = function () {
            _this.setErrorText(cookiesErrorText);
            _this.showErrorsBlock();
        }
    }

    let controls = new Controls();
    let errors = new Errors();
    let hideClass = 'hide';
    let videohostingIframeWrapper = window.document.querySelector(`#${containerID} .videohosting-player__embed`);
    let isLoading = false;
    let playerSizeRatio = 1.77;

    function updatePlayerSize() {
        let controlsBlock = controls.getControlsBlock();
        let controlWidth = controlsBlock.parentNode.offsetWidth;

        let height = Math.round(controlWidth / playerSizeRatio);
        if (isNaN(height)) {
            console.error('height is NaN');
            return;
        }

        if (height > 600) {
            height = 600;
        }

        controlsBlock.parentNode.style.height = height + 'px';
    }

    function loadYoutubeScript() {
        let tag = document.createElement('script');
        tag.addEventListener('error', function () {
            controls.hideControlsBlock();
            // errors.showErrorPlayerLoad();
        });
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function startLoadingPlayer() {
        if (isLoading) {
            return;
        }

        iframeBlock.id = containerID + '-iframe'

        updatePlayerSize();

        if (document.cookie.match(/social_media_cookies/g) === null) {
            controls.hideControlsBlock();
            errors.showCookieError();
            return;
        }

        isLoading = true;
        controls.showSpinner();
        controls.hidePlayButton();

        if (player === 'rutube') {
            const rt = new Rutube();

            rt.Player(iframeBlock.id, {
                width: '100%',
                height: '100%',
                videoId: videoID,
                // events: {
                // onStateChange: onPlayerStateChange,
                // },
            });

            window.addEventListener('message', function (event) {
                let message = JSON.parse(event.data);
                let iframe = document.getElementById(`rt-${iframeBlock.id}`);


                //можно обрабатывать различные события Rutube
                switch (message.type) {
                    case 'player:ready':
                        controls.hideControlsBlock();
                        removeClass(videohostingIframeWrapper, hideClass);

                        rt.play({});

                        break;

                    case 'player:changeFullscreen':
                        if (message.data.isFullscreen) {
                            iframe.requestFullscreen();
                        }

                        if (!message.data.isFullscreen) {
                            if (document.fullscreenElement) {
                                document.exitFullscreen();
                            }
                        }

                        break;
                }
            });
        }

        if (player === 'youtube') {
            loadYoutubeScript();
            let player;
            window.onYouTubeIframeAPIReady = function () {
                player = new window.YT.Player(iframeBlock.id, {
                    height: '100%',
                    width: '100%',
                    videoId: videoID,
                    events: {'onReady': onPlayerReady},
                    playerVars: {rel: 0, origin: window.location.origin}
                });
            }

            function onPlayerReady(event) {
                controls.hideControlsBlock();
                removeClass(videohostingIframeWrapper, hideClass);

                event.target.playVideo();
            }
        }
    }

    this.updatePlayerSizeRatio = function () {
        let img = document.querySelector('.videohosting-player__controls img');
        if (!img) {
            console.error('img not found');
            return;
        }
        playerSizeRatio = img.clientWidth / img.clientHeight;
    }

    this.registerHandlers = function () {
        controls.getControlsBlock().addEventListener('click', function () {
            startLoadingPlayer()
        });

        window.addEventListener('resize', updatePlayerSize);
        updatePlayerSize();
    }

    // this.updatePlayerSizeRatio();
    this.registerHandlers();
}




// WEBPACK FOOTER //
// ./js/main/module/videohosting-player.js